class ReadonlyURLSearchParamsError extends Error {
  constructor() {
    super('Method unavailable on `ReadonlyURLSearchParams`.');
  }
}

/**
 * A subclass of `URLSearchParams` that enforces read-only access. Borrowed from https://github.com/vercel/next.js/blob/c49b7b11e85d64e5cefa79dc3372437fab451e4f/packages/next/src/client/components/navigation.react-server.ts#L10
 *
 * Any attempt to modify the search parameters using mutating methods
 * (`set`, `append`, `delete`, or `sort`) will throw a `ReadonlyURLSearchParamsError`.
 * */
export class ReadOnlyURLSearchParams extends URLSearchParams {
  set() {
    throw new ReadonlyURLSearchParamsError();
  }
  append() {
    throw new ReadonlyURLSearchParamsError();
  }
  delete() {
    throw new ReadonlyURLSearchParamsError();
  }
  sort() {
    throw new ReadonlyURLSearchParamsError();
  }
}